import ApiService from '@/services/api.service'

const HealthProtocolService = {
    getAll() { 
      const requestData = {
        method: 'get',
        url: "/HealthProtocolHdrs/",
        headers: {
        },
      }     
      return ApiService.customRequest(requestData);         
    },
  
    get( id) {
      return ApiService.get(`/HealthProtocolHdrs/${id}`);
    },

    add(data){
      return ApiService.post(`/HealthProtocolHdrs`,data)
    },

    delete(id){
      return ApiService.delete(`/HealthProtocolHdrs/${id}`)
    },

    update(RecordId, healthprotocol){
      return ApiService.put(`/HealthProtocolHdrs/${RecordId}`,healthprotocol)
    }
}
  
  export default HealthProtocolService;